import React, { createContext, useContext, useState } from 'react';

const AuthContext = createContext(null);

function decodeJwt(token) {
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch {
    return null;
  }
}

function userFromToken(token) {
  if (!token) return null;
  const p = decodeJwt(token);
  if (!p) return null;
  return { id: p.user_id ?? null, username: p.sub, is_admin: !!p.is_admin };
}

export function AuthProvider({ children }) {
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [user, setUser]   = useState(() => userFromToken(localStorage.getItem('token')));

  const login = (t) => {
    localStorage.setItem('token', t);
    setToken(t);
    setUser(userFromToken(t));
  };

  const logout = () => {
    localStorage.removeItem('token');
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ token, user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
